        function handleIndex() {
          var articleContent = document.querySelector('.mat-article-template__content');
          var h1Tags = []
          if(articleContent) {
            h1Tags = articleContent.querySelectorAll('h2');
          }
          var counter = 1;
          var ulElement = document.createElement('ul');

          for (var i = 0; i < h1Tags.length; i++) {
            var h1Tag = h1Tags[i];

            if (! h1Tag.classList.contains('mat-article__title')) {
              h1Tag.id = 'title-' + counter;
              var liElement = document.createElement('li');
              liElement.id = 'li-title-' + counter;
              var linkElement = document.createElement('a');
              linkElement.href = '#' + h1Tag.id;
              linkElement.textContent = h1Tag.innerText;
              liElement.appendChild(linkElement);
              ulElement.appendChild(liElement);
              counter++;
            }
          }
          var indexElement = document.querySelector('.mat-article-template__index');
          if(indexElement) {
            indexElement.appendChild(ulElement);
          }
        }
        document.addEventListener('DOMContentLoaded', function() {
          handleIndex();
        });
        function handleCurrentIndexItem() {
          const articleContent = document.querySelector('.mat-article-template__content');
          let articleTitles = []
          if(articleContent) {
            articleTitles = [... articleContent.querySelectorAll('h2[id^="title-"]')];
          }

          let currentTitle = 100000;

          articleTitles.forEach((articleTitle) => {
            const titleRect = articleTitle.getBoundingClientRect();
            const titleOffsetTop = titleRect.top;
            if (titleOffsetTop > 0 && titleOffsetTop < currentTitle) {
              currentTitle = titleOffsetTop;
              const currentIndexItem = document.querySelector('a[href^="#title-"].-current');
              if (currentIndexItem) {
                currentIndexItem.classList.remove('-current');
              }
              document.querySelector(`a[href='#${
                articleTitle.id
              }']`).classList.add('-current');
            }
          });
        }
        document.addEventListener('scroll', function() {
          handleCurrentIndexItem();
        });
